import AppConstants from '../config/app.constants';

let ActionCodeService = function ($http, $q) {

    let create = (data, branch) => {
        return $http
            .post(AppConstants.api + `/action-code/create`, {
                data,
                branch
            })
            .then((res) => {
                return res.data
            })
    }

    let all = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/action-code`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let getActionCodes = (actionCodeId) => {
        return $http
            .get(AppConstants.api + `/action-code/get-action-codes`, {
                params: { actionCodeId }
            })
            .then((res) => {
                return res.data
            })
    }

    let updateCodeResponse = (data) => {
        return $http
            .post(AppConstants.api + `/action-code/update-code-response`, data)
            .then((res) => {
                return res.data
            })
    }

    let createServiceOrderActionCodes = (actionCodeLabel, actionCode, minResponse, maxResponse, minRootCause, maxRootCause, thresholds, partsCapture, resolveCodes, rootCauses,
                                         redThreshold, orangeThreshold, yellowThreshold, otherThreshold, branch, requirePicture, openRequired, category, serviceType, expectedCompletionTime, autoAssignable, serviceActionPriorityId, preventativeMaintenanceId) => {
        return $http
            .post(AppConstants.api + `/action-code/create-service-order-action-codes`, {
                actionCodeLabel, actionCode, minResponse, maxResponse, minRootCause, maxRootCause, thresholds, partsCapture, resolveCodes, rootCauses,
                redThreshold, orangeThreshold, yellowThreshold, otherThreshold, branch, requirePicture, openRequired, category, serviceType, expectedCompletionTime, autoAssignable, serviceActionPriorityId, preventativeMaintenanceId
            })
            .then((res) => {
                return res.data
            })
    }

    return {
        create,
        all,
        getActionCodes,
        updateCodeResponse,
        createServiceOrderActionCodes
    }
}

ActionCodeService.$inject = ["$http", "$q"];

export default ActionCodeService;



// WEBPACK FOOTER //
// ./client/app/services/action-code.service.js